import React, { Fragment } from 'react';
import Header from './Header';
import TableLayout from './TableLayout';
import { Query } from 'react-apollo';
import { PORTAL_PAYMENTS_QUERY } from './graphql';
import { connect } from 'react-redux';
import qs from 'qs';

class Payments extends React.Component{

  constructor(props) {
      super(props);

      this.state = {
          data: [],
          skip: 0,
          first: 20,
          initialPage: 0,
          refetch: false
      };

      this.handlePageClick = this.handlePageClick.bind(this);
      this.handleCompletedFetching = this.handleCompletedFetching.bind(this);
  }

  componentDidMount() {
      const params =  qs.parse(window.location.search, {
          ignoreQueryPrefix: true
      });
      const { p: page } = params;
      const initialPage = (page) ? page-1 : 0;
      const skip = (initialPage > 0) ? page * 20 : 0;
      this.setState({
          skip,
          initialPage
      });
  }

  handleCompletedFetching() {
      this.setState({
          refetch: false
      });
  }

  toggleRefetch() {
      const { refetch } = this.props;
      this.setState({
          refetch: !refetch
      });
  }

  handlePageClick(data) {
      const { selected } = data;
      const skip = Math.ceil(selected * 20);
      const initialPage = selected;
      this.setState({
          skip,
          initialPage
      });
      this.props.history.push({
          pathname: '/transacoes',
          search: "?" + new URLSearchParams({
              p: (selected+1)
          }).toString()
      });
    }

  componentDidUpdate(prevProps, prevState) {
      if (this.state.refetch && !prevState.refetch) {
          this.setState({
              refetch: false
          });
      }

      if (JSON.stringify(this.props.filters) !== JSON.stringify(prevProps.filters)) {
          this.setState({
              refetch: true
          });
      }
  }

  render() {
      const { operatorId, filters } = this.props;
      const { first, skip, initialPage } = this.state;
      const variables = {
          operatorId,
          skip,
          first,
          ...filters
      };

      return (
          <Query
              query={PORTAL_PAYMENTS_QUERY}
              variables={variables}
          >
              {({ loading, data, refetch, error }) => {
                  if (this.state.refetch){
                      refetch();
                  }
                  console.log(data)
                  const { portalPayments } = data || {}
                  console.log(portalPayments)
                  const { payments, pages } = portalPayments || {}
                  return(
                      <Fragment>
                          <Header
                          />
                          <div
                              className="containter-fluid mt--6"
                              style={{paddingLeft:"39px",paddingRight:"39px"}}
                          >
                              <div className="row">
                                  <div className='col'>
                                      <TableLayout
                                          error={error}
                                          data={payments}
                                          loading={loading}
                                          initialPage={initialPage}
                                          onPageClick={this.handlePageClick}
                                          pages={pages}
                                          first={first}
                                          skip={first*initialPage}
                                      />
                                  </div>
                              </div>
                          </div>
                      </Fragment>
                  );
              }}
          </Query>
      );
  }
}


const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId,
    filters: state.payments.filters
});

export default connect(mapStateToProps)(Payments);



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/index.js